/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gravity_chain_about = () => `Gravity is a high-performance Layer 1 blockchain built for mass adoption. Gravity achieves high throughput and low-latency finality with a pipelined AptosBFT consensus engine and Grevm (Gravity EVM), a parallel EVM runtime, while maintaining PoS security through restaking technology.`
